import client from '../_client';
import config from '~/config';
import utils from '~/utils';

export const getIntelinvestTokens = (params = {}) => {
    return client.request({
        url: config.api.intelinvest.list,
        method: 'GET',
        params,
    });
};

/**
 * @function createIntelinvestToken
 * @param {Object} data
 * @param {string} [data.name]
 * @param {string} [data.expiresAt] - ISO 8601
 * @returns {*}
 */
export const createIntelinvestToken = (data) => {
    return client.request({
        headers: {
            'X-CSRFToken': utils.network.getCSRFToken(),
        },
        url: config.api.intelinvest.list,
        method: 'POST',
        data,
    });
};

export const removeIntelinvestToken = (data = {}) => {
    const id = data.id;
    delete data.id;
    return client.request({
        headers: {
            'X-CSRFToken': utils.network.getCSRFToken(),
        },
        url: config.api.intelinvest.one.replace('{id}', id),
        method: 'DELETE',
    });
};
